// src/pages/Inicial.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Card from "../components/Card/Card";
import SecaoAutomatica from "../components/Secoes/SecaoAutomatica";
import SecaoManual from "../components/Secoes/SecaoManual";
import projetosData from "../data/projetosGerais.json";
import secoesManuais from "../data/secoesManuais.json";
import ImagemPrincipal from "../img/Image-home.png";
import HeroCarousel from "../components/Hero/HeroCarousel";

function Inicial({ filtro, pesquisa }) {

    const [secaoAtiva, setSecaoAtiva] = useState(null);

    const navigate = useNavigate();

    const location = useLocation();

    /* 🔹 Scroll automático quando vier com âncora (#secao-...) */
    useEffect(function () {
        if (location.hash) {
            const id = location.hash.replace("#", "");

            setTimeout(function () {
                const elemento = document.getElementById(id);

                if (elemento) {

                    const alturaViewport = window.innerHeight;

                    // Queremos alinhar com a zona central (igual ao rootMargin -40%)
                    const offset = alturaViewport * 0.4;

                    const posicao =
                        elemento.getBoundingClientRect().top +
                        window.scrollY -
                        offset;

                    window.scrollTo({
                        top: posicao,
                        behavior: "smooth"
                    });
                }
            }, 100);
        }
    }, [location]);

    useEffect(function () {

        const secoes = document.querySelectorAll("[data-secao]");

        const observer = new IntersectionObserver(
            function (entries) {

                let secaoMaisVisivel = null;
                let maiorRatio = 0;

                entries.forEach(function (entry) {
                    if (entry.intersectionRatio > maiorRatio) {
                        maiorRatio = entry.intersectionRatio;
                        secaoMaisVisivel = entry.target;
                    }
                });

                if (secaoMaisVisivel) {
                    const id = secaoMaisVisivel.getAttribute("data-secao");
                    setSecaoAtiva(id);
                }
            },
            {
                root: null,
                rootMargin: "-40% 0px -40% 0px",
                threshold: 0
            }
        );

        secoes.forEach(function (secao) {
            observer.observe(secao);
        });

        return function () {
            observer.disconnect();
        };

    }, []);

    const handleCardClick = (id) => {
        navigate(`/projeto/${id}`);
    };

    // Função de filtragem global
    function filtrarProjetos() {
        let projetos = [...projetosData];

        // Se houver pesquisa, prioriza ela
        if (pesquisa && pesquisa.trim() !== "") {
            return projetos.filter(
                (proj) =>
                    proj.titulo.toLowerCase().includes(pesquisa.toLowerCase()) ||
                    proj.descricao.toLowerCase().includes(pesquisa.toLowerCase())
            );
        }

        // Se houver filtro ativo
        if (filtro && filtro !== "todos") {
            return projetos.filter((proj) => proj.tags.includes(filtro));
        }

        // Caso contrário → sem filtros/pesquisa
        return null;
    }

    const projetosFiltrados = filtrarProjetos();

   const idsHero = [1, 7, 12];
   
       const slidesHero = projetosData
           .filter(function (projeto) {
               return idsHero.includes(projeto.id);
           })
           .map(function (projeto) {
               return {
                   imagem: ImagemPrincipal,
                   projetoId: projeto.id,
                   titulo: projeto.titulo
               };
           });

    return (
        <div>
            <HeroCarousel slides={slidesHero} />

            {/* CONTEÚDO COM RESPIRO */}

            <div className="pagina-inicial-conteudo">

                {projetosFiltrados ? (
                    // 🔹 Lista filtrada simples
                    <div className="cards-container">
                        {projetosFiltrados.map((projeto) => (
                            <Card key={projeto.id} projeto={projeto} onClick={handleCardClick} />
                        ))}
                    </div>
                ) : (
                    // 🔹 Estado inicial (sem filtros/pesquisa) → renderiza seções
                    <>
                        {/* Seções manuais (ex: Destaques, Novidades) */}
                        {/*{Object.entries(secoesManuais).map(function (entrada) {

                            const titulo = entrada[0];
                            const ids = entrada[1];

                            return (
                                <div className="secao-wrapper" key={titulo} >

                                    <div className="secao-lateral">
                                        <span className="secao-tag" style={{ transform: "translate(-50%, 20%) rotate(-90deg)" }} >{titulo}</span>
                                        <div className="secao-linha"></div>
                                    </div>

                                    <div className="secao-conteudo" style={{ marginTop: "1%" }}>
                                        <SecaoManual
                                            ids={ids}
                                            projetos={projetosData}
                                        />
                                    </div>

                                </div>
                            );
                        })} */}

                        {/* ========================= APRESENTAÇÃO ========================= */}

                        <div className="secao-wrapper">

                            <div className="secao-lateral">
                                <div className="secao-linha"></div>
                            </div>

                            <div className="secao-conteudo">
                                <div className="apresentacao">
                                    <h1 className="apresentacao-titulo">
                                        Portfólio de Tecnologias Educacionais
                                    </h1>

                                    <p className="apresentacao-texto">
                                        Explore recursos, compare possibilidades e encontre soluções inovadoras
                                        que transformam o aprendizado em experiências envolventes e criativas.
                                    </p>
                                </div>
                            </div>

                        </div>


                        <div
                            className="secao-wrapper"
                            data-secao="rv"
                            id="secao-rv"
                        >
                            <div className="secao-lateral">
                                <span className={`secao-tag ${secaoAtiva === "rv" ? "ativa" : ""}`}>
                                    RV
                                </span>
                                <div className="secao-linha"></div>
                            </div>

                            <div className="secao-conteudo">
                                <SecaoAutomatica
                                    tag="RV"
                                    projetos={projetosData}
                                />
                            </div>
                        </div>

                        <div
                            className="secao-wrapper"
                            data-secao="ra"
                            id="secao-ra"
                        >
                            <div className="secao-lateral">
                                <span className={`secao-tag ${secaoAtiva === "ra" ? "ativa" : ""}`}>
                                    RA
                                </span>
                                <div className="secao-linha"></div>
                            </div>

                            <div className="secao-conteudo">
                                <SecaoAutomatica
                                    tag="RA"
                                    projetos={projetosData}
                                />
                            </div>
                        </div>

                        <div
                            className="secao-wrapper"
                            data-secao="video360"
                            id="secao-video360"
                        >
                            <div className="secao-lateral">
                                <span className={`secao-tag ${secaoAtiva === "video360" ? "ativa" : ""}`}>
                                    VÍDEO 360
                                </span>
                                <div className="secao-linha"></div>
                            </div>

                            <div className="secao-conteudo">
                                <SecaoAutomatica
                                    tag="Vídeo 360"
                                    projetos={projetosData}
                                />
                            </div>
                        </div>

                        <div
                            className="secao-wrapper"
                            data-secao="video360i"
                            id="secao-video360i"
                        >
                            <div className="secao-lateral">
                                <span className={`secao-tag ${secaoAtiva === "video360i" ? "ativa" : ""}`}>
                                    VÍDEO 360i
                                </span>
                                <div className="secao-linha"></div>
                            </div>

                            <div className="secao-conteudo">
                                <SecaoAutomatica
                                    tag="Vídeo 360i"
                                    projetos={projetosData}
                                />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default Inicial;
